import { render, staticRenderFns } from "./CloundbtnInfoLoad.vue?vue&type=template&id=64953d08&scoped=true&"
import script from "./CloundbtnInfoLoad.vue?vue&type=script&lang=ts&"
export * from "./CloundbtnInfoLoad.vue?vue&type=script&lang=ts&"
import style0 from "./CloundbtnInfoLoad.vue?vue&type=style&index=0&id=64953d08&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64953d08",
  null
  
)

export default component.exports